export default "__VITE_ASSET__BVpmDovj__"